<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g transform="matrix(1,0,0,1,-2430,-4320)">
      <g id="FinishScreen" transform="matrix(0.5,0,0,0.5,2430,4320)">
        <rect x="0" y="0" width="2160" height="3840" style="fill: none" />
        <clipPath id="_clip1">
          <rect x="0" y="0" width="2160" height="3840" />
        </clipPath>
        <g clip-path="url(#_clip1)">
          <g id="background.jpg" transform="matrix(2,0,0,2,0,0)">
            <image
              href="../assets/background.jpg"
              x="0"
              y="0"
              width="1080px"
              height="1920px"
            />
          </g>
          <g transform="matrix(2,0,0,2.04764,-4859.2,-8806.45)">
            <path
              d="M3415.32,4514.35C3417.97,4514.35 3420.51,4515.38 3422.39,4517.21C3424.26,4519.04 3425.32,4521.53 3425.32,4524.12C3425.32,4570.18 3425.32,4765.4 3425.32,4811.46C3425.32,4814.05 3424.26,4816.53 3422.39,4818.36C3420.51,4820.2 3417.97,4821.23 3415.32,4821.23C3322.94,4821.23 2619.55,4821.23 2527.16,4821.23C2524.51,4821.23 2521.97,4820.2 2520.09,4818.36C2518.22,4816.53 2517.16,4814.05 2517.16,4811.46C2517.16,4765.4 2517.16,4570.18 2517.16,4524.12C2517.16,4521.53 2518.22,4519.04 2520.09,4517.21C2521.97,4515.38 2524.51,4514.35 2527.16,4514.35C2619.55,4514.35 3322.94,4514.35 3415.32,4514.35Z"
              style="fill: white"
            />
          </g>
          <g transform="matrix(1.00072,0,0,1.00072,0,-39.5997)">
            <g transform="matrix(1.99855,0,0,1.99855,-5183.28,-8530.32)">
              <g transform="matrix(110.58,0,0,110.58,3460.59,4643.87)"></g>
              <text
                x="2800px"
                y="4643.87px"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 500;
                  font-size: 110.58px;
                  fill: rgb(40, 110, 182);
                "
              >
                Goed gedaan!
              </text>
            </g>
            <g transform="matrix(1.99855,0,0,1.99855,-5217.25,-8578.44)">
              <text
                x="2740px"
                y="4785.48px"
                style="
                  font-family: 'Inter', 'Open Sans', sans-serif;
                  font-weight: 500;
                  font-size: 100.072px;
                  fill: rgb(22, 38, 78);
                "
              >
                Jouw score is {{ getScore }}
              </text>
            </g>
          </g>
          <g class="swing">
            <g
              id="hand"
              transform="matrix(0.712418,0,0,0.712418,511.956,32.2633)"
            >
              <g transform="matrix(1,0,0,1,1509.54,192.175)">
                <path
                  d="M0,386.867C34.394,389.376 69.574,384.384 102.817,372.159L228.348,325.994C228.55,325.92 228.723,325.821 228.86,325.723C228.761,324.96 228.505,324.878 228.273,324.804L126.797,292.377L234.379,252.816C235.408,252.438 236.04,251.686 236.299,251.236C236.206,251.1 236.054,250.988 235.795,250.976L54.221,242.817L233.767,176.788C233.888,176.743 234.025,176.693 234.136,176.436C234.157,176.388 234.172,176.344 234.182,176.304C233.586,176.083 232.472,175.909 231.357,176.318L228.512,177.364C228.472,177.379 228.434,177.393 228.395,177.408L203.137,108.725L203.143,108.723C203.469,108.599 203.636,108.233 203.515,107.904C203.409,107.614 203.273,107.448 203.161,107.354L18.834,175.14L9.611,134.528C9.337,133.317 2.827,104.524 -1.741,73.467C-4.292,56.123 -8.15,41.49 -16.792,28.307C-13.065,41.19 -9.89,52.714 -8.577,58.857C-5.451,73.489 -4.368,110.373 -11.749,146.561C-19.473,184.433 -34.64,214.027 -56.252,233.905L0,386.867ZM85.208,453.331C46.61,461.739 6.893,462.968 -31.659,456.788L-53.559,453.25L-146.655,200.098L-115.196,186.245C-96.775,178.133 -87.927,153.012 -83.75,133.366C-77.928,105.993 -79.263,79.329 -80.176,73.987C-82.697,62.366 -96.782,15.649 -105.111,-11.204C-105.111,-11.204 -108.81,-23.522 -106.544,-31.451C-104.544,-38.451 -97.241,-46.653 -97.241,-46.653C-94.636,-49.518 -84.895,-59.325 -68.897,-65.208L-68.891,-65.211C-53.732,-70.782 -23.301,-76.101 10.19,-49.128C30.181,-33.03 44.856,-14.587 55.053,7.252C64.672,27.854 68.447,47.771 70.66,62.82C71.38,67.714 72.158,72.574 72.955,77.267L181.876,37.211L183.831,36.619L184.498,36.445C202.274,31.79 221.043,33.984 237.335,42.63C253.477,51.195 265.858,65.407 272.198,82.646C276.293,93.783 277.524,105.286 276.268,116.342C287.345,124.012 296.019,134.548 301.387,147.087C309.331,165.645 309.313,186.9 301.339,205.402C300.366,207.658 299.284,209.855 298.097,211.988C302.377,218.726 305.557,226.181 307.517,234.169C311.967,252.295 309.18,271.352 299.671,287.828C298.313,290.18 296.833,292.452 295.242,294.634C299.873,304.732 302.21,315.867 302.077,327.484C301.904,342.577 296.94,357.05 287.721,369.341C279.054,380.896 267.257,389.657 253.606,394.677L128.076,440.841C114.027,446.007 99.694,450.175 85.208,453.331"
                  style="
                    fill: rgb(12, 22, 61);
                    fill-rule: nonzero;
                    stroke: white;
                    stroke-width: 0px;
                    stroke-linejoin: round;
                    stroke-linecap: round;
                  "
                />
              </g>
              <g transform="matrix(1,0,0,1,1333.2,617.771)">
                <path
                  d="M0,-149.388L58.684,10.188L85.275,0.41L26.591,-159.167L0,-149.388ZM62.369,86.205C49.993,88.901 37.138,87.512 25.44,82.105C11.238,75.54 0.442,63.837 -4.958,49.152L-73.723,-137.836C-84.87,-168.15 -69.278,-201.881 -38.964,-213.03L15.039,-232.889C29.724,-238.289 45.633,-237.648 59.835,-231.083C74.037,-224.518 84.833,-212.815 90.233,-198.13L158.998,-11.143C170.146,19.172 154.553,52.904 124.239,64.052L70.237,83.911C67.647,84.863 65.019,85.628 62.369,86.205"
                  style="
                    fill: rgb(12, 22, 61);
                    fill-rule: nonzero;
                    stroke: white;
                    stroke-width: 0px;
                    stroke-linejoin: round;
                    stroke-linecap: round;
                  "
                />
              </g>
              <g transform="matrix(1,0,0,1,1453.38,616.541)">
                <path
                  d="M0,-454.756C10.18,-458.498 25.358,-459.137 43.507,-444.52C77.389,-417.237 86.314,-385.761 90.728,-355.745C95.142,-325.731 101.561,-297.464 101.561,-297.464L231.028,-345.075L246.336,-350.705L249.768,-351.967L249.796,-351.781C268.128,-356.583 287.45,-346.765 294.125,-328.614C301.222,-309.316 291.331,-287.919 272.035,-280.823L274.997,-281.912C293.917,-288.87 316.085,-280.934 324.019,-262.402C332.479,-242.639 322.581,-220.084 302.665,-212.76L293.706,-209.465C309.573,-208.753 324.11,-197.869 328.251,-180.997C332.835,-162.325 321.321,-143.368 303.276,-136.732L295.68,-133.938C310.372,-129.243 321.973,-115.6 321.758,-96.822C321.586,-81.817 311.33,-68.733 297.246,-63.553L296.339,-63.22L281.939,-57.924L171.715,-17.39C126.584,-0.793 77.88,4.381 30.401,-3.229L29.667,-3.348L-44.181,-204.158C18.289,-231.668 15.583,-340.191 11.909,-357.387C8.235,-374.584 -12.502,-428.8 -13.379,-435.817C-14.379,-443.817 -8.824,-451.511 0,-454.756"
                  style="
                    fill: rgb(12, 22, 61);
                    fill-rule: nonzero;
                    stroke: white;
                    stroke-width: 8px;
                    stroke-linejoin: round;
                    stroke-linecap: round;
                  "
                />
              </g>
              <g transform="matrix(1,0,0,1,1438.7,441.466)">
                <path
                  d="M0,208.399L-54.002,228.258C-65.399,232.45 -78.035,226.608 -82.226,215.211L-150.991,28.224C-155.182,16.827 -149.341,4.191 -137.944,0L-83.942,-19.86C-72.545,-24.051 -59.909,-18.209 -55.718,-6.813L13.047,180.175C17.238,191.572 11.397,204.208 0,208.399"
                  style="
                    fill: rgb(12, 22, 61);
                    fill-rule: nonzero;
                    stroke: white;
                    stroke-width: 8px;
                    stroke-linejoin: round;
                    stroke-linecap: round;
                  "
                />
              </g>
            </g>
          </g>
          <g id="HighScoreBack">
            <g transform="matrix(1.00072,0,0,1.00072,0,393.81)">
              <g opacity="0.84">
                <g transform="matrix(1,0,0,1,1972.47,845.585)">
                  <path
                    d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
                    style="fill: white; fill-rule: nonzero"
                  />
                </g>
              </g>
            </g>
            <g transform="matrix(1.00072,0,0,1.00072,0,393.81)">
              <g opacity="0.84">
                <g transform="matrix(1,0,0,1,1972.47,1157.75)">
                  <path
                    d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
                    style="fill: white; fill-rule: nonzero"
                  />
                </g>
              </g>
            </g>
            <g transform="matrix(1.00072,0,0,1.00072,-1.69943,709.875)">
              <g opacity="0.84">
                <g transform="matrix(1,0,0,1,1972.47,1157.75)">
                  <path
                    d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
                    style="fill: white; fill-rule: nonzero"
                  />
                </g>
              </g>
            </g>
            <g transform="matrix(1.00072,0,0,1.00072,0,393.81)">
              <g opacity="0.84">
                <g transform="matrix(1,0,0,1,1972.47,1782.09)">
                  <path
                    d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
                    style="fill: white; fill-rule: nonzero"
                  />
                </g>
              </g>
            </g>
            <g transform="matrix(1.00072,0,0,1.00072,0,393.81)">
              <g opacity="0.84">
                <g transform="matrix(1,0,0,1,1972.47,2094.25)">
                  <path
                    d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
                    style="fill: white; fill-rule: nonzero"
                  />
                </g>
              </g>
            </g>
            <g transform="matrix(1.00072,0,0,1.00072,0,393.81)">
              <g opacity="0.84">
                <g transform="matrix(1,0,0,1,1972.47,2406.42)">
                  <path
                    d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
                    style="fill: white; fill-rule: nonzero"
                  />
                </g>
              </g>
            </g>
            <g transform="matrix(1.00072,0,0,1.00072,0,393.81)">
              <g opacity="0.84">
                <g transform="matrix(1,0,0,1,1972.47,2718.59)">
                  <path
                    d="M0,258.817L-1781.54,258.817C-1790.78,258.817 -1798.27,251.326 -1798.27,242.085L-1798.27,16.733C-1798.27,7.492 -1790.78,0 -1781.54,0L0,0C9.241,0 16.732,7.492 16.732,16.733L16.732,242.085C16.732,251.326 9.241,258.817 0,258.817"
                    style="fill: white; fill-rule: nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
          <g transform="matrix(2,0,0,2,-5845.49,-8631.71)">
            <g transform="matrix(65,0,0,65,3098.39,5023.54)"></g>
            <text
              x="3062.25px"
              y="5023.54px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              1
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5845.49,-8319.09)">
            <g transform="matrix(65,0,0,65,3098.39,5023.54)"></g>
            <text
              x="3062.25px"
              y="5023.54px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              2
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5845.49,-8006.47)">
            <g transform="matrix(65,0,0,65,3098.39,5023.54)"></g>
            <text
              x="3062.25px"
              y="5023.54px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              3
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5845.49,-7693.85)">
            <g transform="matrix(65,0,0,65,3098.39,5023.54)"></g>
            <text
              x="3062.25px"
              y="5023.54px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              4
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5845.49,-7381.22)">
            <g transform="matrix(65,0,0,65,3098.39,5023.54)"></g>
            <text
              x="3062.25px"
              y="5023.54px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              5
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5845.49,-7068.6)">
            <g transform="matrix(65,0,0,65,3098.39,5023.54)"></g>
            <text
              x="3062.25px"
              y="5023.54px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              6
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5845.49,-6755.98)">
            <g transform="matrix(65,0,0,65,3098.39,5023.54)"></g>
            <text
              x="3062.25px"
              y="5023.54px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              7
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5607.59,-8933.93)">
            <text
              x="3015.37px"
              y="5174.45px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getName(0) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5607.59,-8621.3)">
            <text
              x="3015.37px"
              y="5174.45px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getName(1) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5607.59,-8308.68)">
            <text
              x="3015.37px"
              y="5174.45px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getName(2) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5607.59,-7996.06)">
            <text
              x="3015.37px"
              y="5174.45px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getName(3) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5607.59,-7683.44)">
            <text
              x="3015.37px"
              y="5174.45px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getName(4) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5607.59,-7370.81)">
            <text
              x="3015.37px"
              y="5174.45px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getName(5) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,-5607.59,-7058.19)">
            <text
              x="3015.37px"
              y="5174.45px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getName(6) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,1722.56,1415.69)">
            <g transform="matrix(65,0,0,65,72.9834,0)"></g>
            <text
              x="-18.062px"
              y="0px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 700;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getScores(0) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,1722.56,1728.31)">
            <g transform="matrix(65,0,0,65,72.9834,0)"></g>
            <text
              x="-18.062px"
              y="0px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 700;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getScores(1) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,1722.56,2040.93)">
            <g transform="matrix(65,0,0,65,72.9834,0)"></g>
            <text
              x="-18.062px"
              y="0px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 700;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getScores(2) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,1722.56,2353.56)">
            <g transform="matrix(65,0,0,65,72.9834,0)"></g>
            <text
              x="-18.062px"
              y="0px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 700;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getScores(3) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,1722.56,2666.18)">
            <g transform="matrix(65,0,0,65,72.9834,0)"></g>
            <text
              x="-18.062px"
              y="0px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 700;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getScores(4) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,1722.56,2978.8)">
            <g transform="matrix(65,0,0,65,72.9834,0)"></g>
            <text
              x="-18.062px"
              y="0px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 700;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getScores(5) }}
            </text>
          </g>
          <g transform="matrix(2,0,0,2,1722.56,3291.42)">
            <g transform="matrix(65,0,0,65,72.9834,0)"></g>
            <text
              x="-18.062px"
              y="0px"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 700;
                font-size: 65px;
                fill: rgb(12, 22, 61);
              "
            >
              {{ getScores(6) }}
            </text>
          </g>
        </g>
      </g>
    </g>
    <defs></defs>
  </svg>
</template>

<script>
export default {
  name: "FinishScreen",
  created() {
    //this.$store.dispatch("getHiScore");
    this.timer = setInterval(this.gotoInactive, 15000);
  },
  computed: {
    getScore() {
      return this.$store.getters.getScore;
    },
  },
  methods: {
    gotoInactive() {
      this.$store.commit("setGameState", "inactive");
      this.$store.commit("setPlayerState", "ended");
    },
    getName(pos) {
      const hiScores = Array.isArray(this.$store.getters.getHiScore)
        ? this.$store.getters.getHiScore
        : [];

      if (pos >= 0 && pos < hiScores.length && hiScores[pos]) {
        return hiScores[pos].name ?? "";
      }

      return "";
    },
    getScores(pos) {
      const hiScores = Array.isArray(this.$store.getters.getHiScore)
        ? this.$store.getters.getHiScore
        : [];

      if (pos >= 0 && pos < hiScores.length && hiScores[pos]) {
        return hiScores[pos].score ?? "";
      }

      return "";
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>
